import React from 'react';

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  EmptyDataTable,
} from '@occc-app/design-system';

import { State } from './redux';
import { deprecatedStatusBadge } from './DeprecatedStatusBadge';

const renderCombinedContent = (name: any, description: any) => (
  <>
    {name || ''}
    <Typography variant='body2'>{description || ''}</Typography>
  </>
);

interface IOffersTable {
  offers: State['data']['offers'];
  chainId: string;
  push: (url: string, state?: unknown) => unknown;
}

type InstanceState = {
  showModal: boolean;
  offer: State['data']['offers'][0] | null;
};

export class OffersTable extends React.Component<IOffersTable, InstanceState> {
  state: InstanceState = {
    showModal: false,
    offer: null,
  };

  renderTable = () => {
    const { offers, push } = this.props;

    if (offers.length === 0) {
      return;
    }

    const rows = offers.map((offer) => {
      const editAction = () => push(`/offers/${offer.id}`);

      return (
        <TableRow key={offer.id} onClick={offer.discontinued ? undefined : editAction}>
          <TableCell>{renderCombinedContent(offer.name, offer.description)}</TableCell>
          <TableCell>{renderCombinedContent(offer.title, offer.description)}</TableCell>
          <TableCell>{offer.category}</TableCell>
          <TableCell>
            {deprecatedStatusBadge(offer.publishAt, offer.expireAt, offer.discontinued)}
          </TableCell>
          <TableCell align='right'>{offer.fulfilled || '0'}</TableCell>
        </TableRow>
      );
    });

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Details</TableCell>
            <TableCell>Marketing Content</TableCell>
            <TableCell>Identifiers</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align='right'>Fulfilled</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  render() {
    return <>{this.renderTable() || <EmptyDataTable />}</>;
  }
}
